import { createSelector } from 'reselect';
import type { RootState } from '../../configuration/setup/store';

export const selectTour = (state: RootState) => state.tour;
export const selectTourId = createSelector(selectTour, state => state.tourId);
export const selectTourItineraryId = createSelector(selectTour, state => state.tourItineraryId);
export const selectFetchTourPending = createSelector(selectTour, state => state.fetchTourPending);
export const selectSelectedItinerary = createSelector(selectTour, state => state.selectedItinerary);
export const selectItineraries = createSelector(selectTour, state => state.itineraries);
export const selectItinerary = createSelector(selectSelectedItinerary, selectItineraries, (selected, itineraries) =>
    selected !== undefined && itineraries !== undefined ? itineraries?.at(selected) : undefined
);
export const selectCurrentTour = createSelector(selectTour, state => state.currentTour);
export const selectTourVehicleId = createSelector(selectTour, state => state.currentTour?.vehicle.vehicleId);
export const selectSettingsSnapshot = createSelector(selectTour, state => state.settingsSnapshot);

// Tour handling flow — itineraries fetched when browsing existing tours (TourDetailsManagerPage).
// Kept separate from the planning flow itineraries so that viewing a tour never clobbers the
// user's current route settings.
export const selectTourHandlingItineraries = createSelector(selectTour, state => state.tourHandlingItineraries);
export const selectTourHandlingSelectedItinerary = createSelector(
    selectTour,
    state => state.tourHandlingSelectedItinerary
);
export const selectTourHandlingItinerary = createSelector(
    selectTourHandlingSelectedItinerary,
    selectTourHandlingItineraries,
    (selected, itineraries) =>
        selected !== undefined && itineraries !== undefined ? itineraries?.at(selected) : undefined
);
